export const formatTime = (date: Date) => {
  // get hours and minutes from the provided date
  const hours: number = date.getHours();
  const minutes: number = date.getMinutes();

  // format hours in 12-hour format
  const formattedHours: number = hours % 12 || 12;
  // add leading zero to minutes if less than 10
  const formattedMinutes: string =
    minutes < 10 ? "0" + minutes : minutes.toString();

  // determine the period of the day (AM or PM)
  const period: string = hours >= 12 ? "pm" : "am";

  // combine formatted hours, minutes, and period into a single string
  const formattedTime: string = `${formattedHours}:${formattedMinutes} ${period}`;

  // return the formatted time string
  return formattedTime;
};
